import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { STATIC_ROOT } from '../../constants';

import SvgComponent from '../SvgComponent';

import './PaymentLockLabel.scss';

/**
 * Mention "Paiement 100% sécurisé" avec son cadenas.
 * Le libellé vient de l'i18n par défaut ; passer `label` pour le surcharger.
 */
const PaymentLockLabel = ({ label, i18nLabel }) => {
    return (
        <div className="lock-label">
            <SvgComponent
                src={`${STATIC_ROOT}/lockpad.svg`}
                width="14"
                height="14"
                aria-hidden="true"
                focusable="false"
            />
            <span className="lockpad-label">{label ? label : i18nLabel}</span>
        </div>
    );
};

PaymentLockLabel.propTypes = {
    label: PropTypes.string
};

const mapStateToProps = state => {
    return {
        i18nLabel: state.i18n.feature.form.PAYMENT_LOCKPAD_LABEL
    };
};

export default connect(mapStateToProps)(PaymentLockLabel);



// WEBPACK FOOTER //
// ./src/components/button/PaymentLockLabel.js